import { ClientPortalBannerPhase } from "@/redux/slices/operator/types";

export type AnnouncementAudience = "operator" | "client";

type Message = { lead: string; body: string };

/**
 * Every phase-and-audience pair the Client Portal announcement can take (DEV-1486).
 *
 * Copy varies by AUDIENCE and PHASE, never by which app you happen to be in. An operator crosses
 * between the legacy pages and the new dashboard constantly during the migration, so one event has
 * to read as one message — these strings are word for word what the legacy banner renders (see
 * `client-portal-announcement.phtml`, which holds the same four). A client and an operator do get
 * different sentences, because they are gaining different things.
 *
 * Within an audience only the LEAD changes between phases: the same release is coming and then has
 * arrived, so rewording the body would read as two separate releases.
 *
 * Keeping all four here means a surface cannot quietly invent its own wording, and adding a surface
 * is a lookup rather than a fresh copy decision.
 */
export const ANNOUNCEMENT_MESSAGES: Record<AnnouncementAudience, Record<Exclude<ClientPortalBannerPhase, "">, Message>> = {
  operator: {
    announcement: {
      lead: "COMING 4 SEP:",
      body: "New Client Manager, new booking flow, and a redesigned Web App for your clients & EAs.",
    },
    live: {
      lead: "NOW LIVE:",
      body: "New Client Manager, new booking flow, and a redesigned Web App for your clients & EAs.",
    },
  },
  client: {
    announcement: {
      lead: "COMING 4 SEP:",
      body: "A brand new booking experience for clients, EAs, and travel managers.",
    },
    live: {
      lead: "NOW LIVE:",
      body: "Your new booking experience is here — redesigned for clients, EAs, and travel managers.",
    },
  },
};
